import { Fetch } from "../utils/fetch";

/**
 * 导出报告的用户下载记录
 * @param {SampleForm} data 保存数据对象
 */
export function exportReportUserDownLoadLoApi(data) {
  return Fetch.fetch({
    url: "UserEnrollInfo/ExportReportUserDownLoadLog",
    method: "POST",
    data,
  });
}
/**
 * 获取报告下载统计和明细列表
 * @param {SampleForm} data
 */
export function getReportDownLoadListByPageApi(data) {
  return Fetch.fetch({
    url: "UserEnrollInfo/GetReportDownLoadListByPage",
    method: "POST",
    data,
  });
}
/**
 * 根据报告分类获取报告文件Id
 * @param {SampleForm} data
 */
export function getReportFileByTypeIdApi(data) {
  return Fetch.fetch({
    url: "MarketReportFile/GetReportFileByTypeId",
    method: "GET",
    params: data,
  });
}
